import { Link } from "@mui/material";

import defaultStyles from "./styles";

interface Props {
  styles?: any;
  href?: string;
  [rest: string]: any;
}

export default function StyledLink({
  children,
  href,
  styles = {},

  ...rest
}: Props) {
  if (!href) {
    return (
      <Link sx={[defaultStyles.link, styles]} {...rest}>
        {children}
      </Link>
    );
  }
  return (
    <Link
      target="_blank"
      rel="noreferrer"
      href={href}
      sx={[defaultStyles.link, styles]}
      {...rest}
    >
      {children}
    </Link>
  );
}
